import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../lib/format-price.js';
import { usePreferencesStore } from '../../stores/preferences.js';

interface QuotaExhaustedToastProps {
  cycleResetDate: string;
  onWait: () => void;
  onUpgrade?: () => void;
  upgradeHref?: string;
}

export function QuotaExhaustedToast({
  cycleResetDate,
  onWait,
  onUpgrade,
  upgradeHref,
}: QuotaExhaustedToastProps) {
  const { t } = useTranslation('dashboard');
  const locale = usePreferencesStore((s) => s.locale);
  const waitLabel = t('quota.waitForRenewal', { date: formatDate(cycleResetDate, locale) });

  return (
    <div className="space-y-3">
      <div className="space-y-1">
        <p className="pr-8 text-h3 font-semibold leading-tight tracking-tight text-primary">
          {t('quota.exhaustedTitle')}
        </p>
        <p className="text-sm leading-snug text-secondary">
          {t('quota.exhaustedDescription')}{' '}
          <button
            type="button"
            onClick={onWait}
            data-variant="ghost"
            className="btn-press text-accent-cyan hover:text-primary hover:underline transition-colors cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-400"
          >
            {waitLabel}.
          </button>
        </p>
      </div>
      <div className="flex justify-end">
        {onUpgrade ? (
          <button
            type="button"
            onClick={onUpgrade}
            className="btn-press inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-lime px-4 py-2 text-sm font-semibold text-canvas transition-[filter] hover:brightness-95 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-400"
          >
            {t('quota.upgradeToPro')}
          </button>
        ) : upgradeHref ? (
          <Link
            to={upgradeHref}
            className="btn-press inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-lime px-4 py-2 text-sm font-semibold text-canvas transition-[filter] hover:brightness-95 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-400"
          >
            {t('quota.upgradeToPro')}
          </Link>
        ) : null}
      </div>
    </div>
  );
}
